import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { cashbox, CashBoxManipulationViewModel } from "./cashBoxManipulation-viewModel"

export class CashBoxManipulationView extends View<CashBoxManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-D4AFED9A-EE2B-481F-B23A-2D3753244CD2"
    }
    loadHtml(): string {
        let element = require('./cashBoxManipulation.html').default;
        let style = require('./cashBoxManipulation.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set cashboxes(v: ObservableArray<cashbox>) { this._cashboxes = v; } public get cashboxes(): ObservableArray<cashbox> { return this._cashboxes;} private _cashboxes: ObservableArray<cashbox>;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;

    addNew(){
        this.dataContext.addNew();
    }
}
